import { createContext, useContext } from 'react'
import type { AuthScreenProps } from './types'

/**
 * The seam `AuthScreen` reads through. `web/src/auth/` (Opus's deliverable) and any dev-only
 * harness both populate this the same way, so `AuthScreen` and everything under
 * `components/auth/` never import either directly.
 */
export const AuthScreenPropsContext = createContext<AuthScreenProps | undefined>(undefined)

export function useAuthScreenProps(): AuthScreenProps {
  const ctx = useContext(AuthScreenPropsContext)
  if (ctx === undefined) {
    throw new Error('useAuthScreenProps() called with no provider mounted (web/src/auth/, or a dev harness)')
  }
  return ctx
}

/** Same seam, for the Drawer's sign-out row — real revocation is `web/src/auth/`'s. */
export const SignOutContext = createContext<(() => void) | undefined>(undefined)

export function useSignOut(): () => void {
  const ctx = useContext(SignOutContext)
  if (ctx === undefined) {
    throw new Error('useSignOut() called with no provider mounted (web/src/auth/, or a dev harness)')
  }
  return ctx
}
